import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import fetchData from '../../../api/fetchData'; 
import './AdminLoginForm.css'; 


function AdminLoginForm({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginStatus, setLoginStatus] = useState({ loading: false, error: null, success: false });
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoginStatus({ loading: true, error: null, success: false });

    const loginData = {
      username: username,
      password: password,
    };

    try { 
      const data = await fetchData('/admin/auth/admin-login.php', 'POST', loginData, { credentials: 'include' });

      if (data && data.status === 'success') {
        setLoginStatus({ loading: false, error: null, success: true });
  
        localStorage.setItem('isAdminLoggedIn', 'true');
       
  
        if (typeof onLogin=== 'function') {
            onLogin(); // Вызываем функцию из App.jsx
        } else {
            console.warn("onLoginSuccess не является функцией или не был передан. Перенаправляем напрямую.");
            navigate('/admin/panel'); 
        }
      } 
   
      else { 
        setLoginStatus({ loading: false, error: data?.message || "Ошибка входа", success: false });
      }
    } catch (error) { // <-- Catch блок для ошибок в fetchData
        setLoginStatus({ loading: false, error: error.message || "Не удалось выполнить запрос", success: false });
    }
  };

  return (
    <form className="admin-login-form" onSubmit={handleSubmit}>
      <h2>Вход администратора</h2>
      <div className="form-group">
        <label htmlFor="username">Имя пользователя:</label>
        <input
          type="text"
          id="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="password">Пароль:</label>
        <input
          type="password"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </div>
      <button type="submit" disabled={loginStatus.loading}>
        {loginStatus.loading ? "Вход..." : "Войти"}
      </button>
      {loginStatus.error && <p className="error-message">{loginStatus.error}</p>}
      {loginStatus.success && <p className="success-message">Вход успешен! Перенаправляю...</p>}
    </form>
  );
}

export default AdminLoginForm;